import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PojectSpendingShopType } from "../../Types/HeyTraderTypes/ProjectSpending/PojectSpendingShopType";
import { getAllSpendingShopList } from "../../Thunks/HeyTraderThunks";

interface ProjectSpendingShopSlice {
    loader: boolean; // for refres pages and inital loadings
    shopList: PojectSpendingShopType[];
    errorDisplay: string | null;
}

// set inital valus
const initialState : ProjectSpendingShopSlice = {
    loader: false,
    shopList: [],
    errorDisplay: '',

}

// set state valu for api response

const ProjectSpendingShopSlice = createSlice ({
    name: 'spendingProjectShops',
    initialState,
    reducers : {
    },
    extraReducers(builder){
        builder.addCase(getAllSpendingShopList.rejected, (state, action) => {
                    state.loader = false;
                    state.errorDisplay = action.error.message!;
                  })
                    .addCase(getAllSpendingShopList.pending, state => {
                    state.loader = true;
                    state.errorDisplay = null;
                  })
                  .addCase(getAllSpendingShopList.fulfilled, (state, action: PayloadAction<PojectSpendingShopType[]>) => {
                    state.loader = false;
                    state.shopList = action.payload;
                  })
    }
})

export const {} = ProjectSpendingShopSlice.actions
export default ProjectSpendingShopSlice.reducer

